import { render, staticRenderFns } from "./ProductCategoryEdit.vue?vue&type=template&id=041d5b9e"
import script from "./ProductCategoryEdit.vue?vue&type=script&lang=js"
export * from "./ProductCategoryEdit.vue?vue&type=script&lang=js"
import style0 from "./ProductCategoryEdit.vue?vue&type=style&index=0&id=041d5b9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports